import { MessageSquare, AlertCircle, Bell, Target, FileCheck } from 'lucide-react';

const FloatingNotifications = () => {
  return (
    <div className="absolute inset-0 w-full h-[200px] overflow-visible pointer-events-none">
      {/* Retainer Signed - top left */}
      <div className="absolute left-[10%] top-[15%] text-gray-600/80 animate-float-1">
        <div className="flex items-center gap-2 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-sm border border-gray-200">
          <FileCheck className="h-4 w-4 text-emerald-500" />
          <span className="text-xs">Retainer agreement signed by Maria G.</span>
        </div>
      </div>

      {/* Medical Release - top right */}
      <div className="absolute right-[10%] top-[15%] text-gray-600/80 animate-float-2">
        <div className="flex items-center gap-2 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-sm border border-gray-200">
          <AlertCircle className="h-4 w-4 text-blue-500" />
          <span className="text-xs">Medical release collected from James T.</span>
        </div>
      </div>

      {/* Documents Sent - middle left */}
      <div className="absolute left-[15%] top-[45%] text-gray-600/80 animate-float-5">
        <div className="flex items-center gap-2 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-sm border border-gray-200">
          <Target className="h-4 w-4 text-purple-500" />
          <span className="text-xs">Intake packet sent to 8 new clients automatically.</span>
        </div>
      </div>

      {/* Reminder Sent - bottom right */}
      <div className="absolute right-[20%] top-[55%] text-gray-600/80 animate-float-3">
        <div className="flex items-center gap-2 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-sm border border-gray-200">
          <Bell className="h-4 w-4 text-orange-500" />
          <span className="text-xs">Follow-up reminder sent via SMS to David R.</span>
        </div>
      </div>
    </div>
  );
};

export default FloatingNotifications; 